/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutItemWrapSX } from '@/components/layouts/styles/itemWrap';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const IntertoysActiesAndFolderLayout3_rv: FC<{ layout: Layout }> = ({ layout }) => {
    const {
		customDimensions: { layoutSpacing }
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
				<Stack
                    id="main-content"
					component="main"
					gap={layoutSpacing}
					sx={layoutMainSX(layout.slots.first?.length || 0)}
				>
					<Container component="section">
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.first} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.second} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.third} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourth} /></Grid> 
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifth} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.six} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seven} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eight} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nine} /></Grid>
                        </Grid>
						<Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ten} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eleven} /></Grid>
                        </Grid>
						<Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twelve} /></Grid>
                        </Grid>
						<Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirteen} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourteen} /></Grid>
                        </Grid>                     
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifteen} /></Grid>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixteen} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventeen} /></Grid> 
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eighteen} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nineteen} /></Grid>                            
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>                           
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twenty} /></Grid>                            
                        </Grid>						
						 <Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyone} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentytwo} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentythree} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyfive} /></Grid>							 
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentysix} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyseven} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyeight} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentynine} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirty} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyone} /></Grid>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtytwo} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtythree} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyfour} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyfive} /></Grid>
                        </Grid> 
						<Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtysix} /></Grid>
                        </Grid>	
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyseven} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtyeight} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirtynine} /></Grid>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.forty} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyone} /></Grid>							
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortytwo} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortythree} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyfive} /></Grid>
                            <Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortysix} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyseven} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortyeight} /></Grid>
                        </Grid> 
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fortynine} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifty} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftyone} /></Grid>
                        </Grid>
						<Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftytwo} /></Grid>
                        </Grid>	
                      	<Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftythree} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftyfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftyfive} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftysix} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftyseven} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftyeight} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fiftynine} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixty} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtyone} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtytwo} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtythree} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtyfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtyfive} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtysix} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtyseven} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtyeight} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixtynine} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventy} /></Grid>
                        </Grid>						
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventyone} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventytwo} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventythree} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventyfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventyfive} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventysix} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventyseven} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventyeight} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventynine} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eighty} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightyone} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightytwo} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightythree} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightyfour} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightyfive} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightysix} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightyseven} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightyeight} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eightynine} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninety} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetyone} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetytwo} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetythree} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetyfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetyfive} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetysix} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetyseven} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetyeight} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ninetynine} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundred} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredone} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredtwo} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredthree} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredfour} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredfive} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredsix} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredseven} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredeight} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundrednine} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredten} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={6} sm={9} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredeleven} /></Grid>
							<Grid item xs={6} sm={3} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredtwelve} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredthirteen} /></Grid>
							<Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredfourteen} /></Grid>
                        </Grid>
						 <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.hundredfifteen} /></Grid>
                        </Grid>                    
					</Container>
	    	</Stack>
            <LayoutSlot slot={layout.slots.footer} />
		</>
	) : null;
};
